export default __webpack_public_path__ + "static/media/popup-desktop.0582b2de.svg";